export default "__VITE_ASSET__C8k9sLuD__"